import React from 'react';
import PropTypes from 'prop-types';

import '../../sass/style.scss';
import { CookiesProvider } from 'react-cookie';

const TemplateWrapper = ({children}) => (
    <div>
        <span style={{display: "none", visibility: "hidden"}}>
            <audio id="nts-player-audio" preload="none" type="audio/mpeg" src="" loop/>
        </span>

        <CookiesProvider>
            {children()}
        </CookiesProvider>
    </div>
);

TemplateWrapper.propTypes = {
    children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js